import Vue from 'vue'
import delayHydration from './hydration/hydrationRace.mjs'

import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_998a5faa from 'nuxt_plugin_plugin_998a5faa' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_09fd370d from 'nuxt_plugin_plugin_09fd370d' // Source: ./nuxt-perfect-cache/plugin.js (mode: 'all')
import nuxt_plugin_image_5652a0bc from 'nuxt_plugin_image_5652a0bc' // Source: ./image.js (mode: 'all')
import nuxt_plugin_recaptcha_b6a32ca0 from 'nuxt_plugin_recaptcha_b6a32ca0' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_3aa0bd2e from 'nuxt_plugin_cookieuniversalnuxt_3aa0bd2e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_stores_0d510f05 from 'nuxt_plugin_stores_0d510f05' // Source: ./stores.js (mode: 'all')
import nuxt_plugin_gtm_b4973252 from 'nuxt_plugin_gtm_b4973252' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginutils_7cd0a49a from 'nuxt_plugin_pluginutils_7cd0a49a' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_413a7365 from 'nuxt_plugin_pluginrouting_413a7365' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_3c68ba2a from 'nuxt_plugin_pluginmain_3c68ba2a' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_bemModifiers_3d89db6f from 'nuxt_plugin_bemModifiers_3d89db6f' // Source: ../plugins/bemModifiers.js (mode: 'all')
import nuxt_plugin_veevalidateclient_6b804bfe from 'nuxt_plugin_veevalidateclient_6b804bfe' // Source: ../plugins/vee-validate.client.js (mode: 'client')
import nuxt_plugin_toast_bdf93834 from 'nuxt_plugin_toast_bdf93834' // Source: ../plugins/toast.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_graphql_134fd164 from 'nuxt_plugin_graphql_134fd164' // Source: ../plugins/graphql.js (mode: 'all')
import nuxt_plugin_clickoutside_5b0e370d from 'nuxt_plugin_clickoutside_5b0e370d' // Source: ../plugins/click-outside.js (mode: 'all')
import nuxt_plugin_scrollpickerclient_ecc5f894 from 'nuxt_plugin_scrollpickerclient_ecc5f894' // Source: ../plugins/scroll-picker.client.js (mode: 'client')
import nuxt_plugin_breakpoints_0eed390b from 'nuxt_plugin_breakpoints_0eed390b' // Source: ../plugins/breakpoints.js (mode: 'all')
import nuxt_plugin_inputmaskclient_102294de from 'nuxt_plugin_inputmaskclient_102294de' // Source: ../plugins/inputmask.client.js (mode: 'client')
import nuxt_plugin_loader_7a10d364 from 'nuxt_plugin_loader_7a10d364' // Source: ../plugins/loader.js (mode: 'all')
import nuxt_plugin_loaderdirectiveclient_359fdea9 from 'nuxt_plugin_loaderdirectiveclient_359fdea9' // Source: ../plugins/loader-directive.client.js (mode: 'client')
import nuxt_plugin_gtm_5e4639ea from 'nuxt_plugin_gtm_5e4639ea' // Source: ../plugins/gtm (mode: 'all')
import nuxt_plugin_jsonld_2ff766e1 from 'nuxt_plugin_jsonld_2ff766e1' // Source: ../plugins/jsonld.js (mode: 'all')
import nuxt_plugin_swipeevents_f3c97d96 from 'nuxt_plugin_swipeevents_f3c97d96' // Source: ../plugins/swipe-events.js (mode: 'all')
import nuxt_plugin_newRelicserver_7388f162 from 'nuxt_plugin_newRelicserver_7388f162' // Source: ../plugins/newRelic.server.js (mode: 'server')
import nuxt_plugin_inviewportclient_6059aa14 from 'nuxt_plugin_inviewportclient_6059aa14' // Source: ../plugins/in-viewport.client.js (mode: 'client')
import nuxt_plugin_pageoverlay_36e17122 from 'nuxt_plugin_pageoverlay_36e17122' // Source: ../plugins/page-overlay.js (mode: 'all')
import nuxt_plugin_nuxtclientinitclient_a7415c48 from 'nuxt_plugin_nuxtclientinitclient_a7415c48' // Source: ../plugins/nuxt-client-init.client.js (mode: 'client')
import nuxt_plugin_tooltipclient_6a09e96b from 'nuxt_plugin_tooltipclient_6a09e96b' // Source: ../plugins/tooltip.client.js (mode: 'client')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../plugins/vuex-persist (mode: 'client')
import nuxt_plugin_performance_1aa850bd from 'nuxt_plugin_performance_1aa850bd' // Source: ../plugins/performance.js (mode: 'client')
import nuxt_plugin_livechatevents_ea8c682a from 'nuxt_plugin_livechatevents_ea8c682a' // Source: ../plugins/livechat-events.js (mode: 'client')
import nuxt_plugin_checkout_520ca9a5 from 'nuxt_plugin_checkout_520ca9a5' // Source: ../node_modules/@strix/checkout/plugins/checkout.js (mode: 'all')
import nuxt_plugin_customer_ea735fe6 from 'nuxt_plugin_customer_ea735fe6' // Source: ../node_modules/@strix/checkout/plugins/customer.js (mode: 'all')
import nuxt_plugin_shipping_35b2603d from 'nuxt_plugin_shipping_35b2603d' // Source: ../node_modules/@strix/checkout/plugins/shipping.js (mode: 'all')
import nuxt_plugin_search_131c6c36 from 'nuxt_plugin_search_131c6c36' // Source: ../node_modules/@strix/search/plugins/search.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    await delayHydration()
}

  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Medicover Vital","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"name":"format-detection","content":"telephone=no"},{"hid":"robots","name":"robots","content":"all"},{"name":"facebook-domain-verification","content":"gj1onxdziixm5ut1b07ehkfot7nt0q"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fico\u002Fmedicoverapteka.ico"}],"bodyAttrs":{"class":"theme--medicoverapteka"},"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-WHF8JMW&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_998a5faa === 'function') {
    await nuxt_plugin_plugin_998a5faa(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_09fd370d === 'function') {
    await nuxt_plugin_plugin_09fd370d(app.context, inject)
  }

  if (typeof nuxt_plugin_image_5652a0bc === 'function') {
    await nuxt_plugin_image_5652a0bc(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_b6a32ca0 === 'function') {
    await nuxt_plugin_recaptcha_b6a32ca0(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_3aa0bd2e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_3aa0bd2e(app.context, inject)
  }

  if (typeof nuxt_plugin_stores_0d510f05 === 'function') {
    await nuxt_plugin_stores_0d510f05(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_b4973252 === 'function') {
    await nuxt_plugin_gtm_b4973252(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_7cd0a49a === 'function') {
    await nuxt_plugin_pluginutils_7cd0a49a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_413a7365 === 'function') {
    await nuxt_plugin_pluginrouting_413a7365(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_3c68ba2a === 'function') {
    await nuxt_plugin_pluginmain_3c68ba2a(app.context, inject)
  }

  if (typeof nuxt_plugin_bemModifiers_3d89db6f === 'function') {
    await nuxt_plugin_bemModifiers_3d89db6f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidateclient_6b804bfe === 'function') {
    await nuxt_plugin_veevalidateclient_6b804bfe(app.context, inject)
  }

  if (typeof nuxt_plugin_toast_bdf93834 === 'function') {
    await nuxt_plugin_toast_bdf93834(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_graphql_134fd164 === 'function') {
    await nuxt_plugin_graphql_134fd164(app.context, inject)
  }

  if (typeof nuxt_plugin_clickoutside_5b0e370d === 'function') {
    await nuxt_plugin_clickoutside_5b0e370d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollpickerclient_ecc5f894 === 'function') {
    await nuxt_plugin_scrollpickerclient_ecc5f894(app.context, inject)
  }

  if (typeof nuxt_plugin_breakpoints_0eed390b === 'function') {
    await nuxt_plugin_breakpoints_0eed390b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_inputmaskclient_102294de === 'function') {
    await nuxt_plugin_inputmaskclient_102294de(app.context, inject)
  }

  if (typeof nuxt_plugin_loader_7a10d364 === 'function') {
    await nuxt_plugin_loader_7a10d364(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_loaderdirectiveclient_359fdea9 === 'function') {
    await nuxt_plugin_loaderdirectiveclient_359fdea9(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_5e4639ea === 'function') {
    await nuxt_plugin_gtm_5e4639ea(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_2ff766e1 === 'function') {
    await nuxt_plugin_jsonld_2ff766e1(app.context, inject)
  }

  if (typeof nuxt_plugin_swipeevents_f3c97d96 === 'function') {
    await nuxt_plugin_swipeevents_f3c97d96(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_newRelicserver_7388f162 === 'function') {
    await nuxt_plugin_newRelicserver_7388f162(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_inviewportclient_6059aa14 === 'function') {
    await nuxt_plugin_inviewportclient_6059aa14(app.context, inject)
  }

  if (typeof nuxt_plugin_pageoverlay_36e17122 === 'function') {
    await nuxt_plugin_pageoverlay_36e17122(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtclientinitclient_a7415c48 === 'function') {
    await nuxt_plugin_nuxtclientinitclient_a7415c48(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_tooltipclient_6a09e96b === 'function') {
    await nuxt_plugin_tooltipclient_6a09e96b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_performance_1aa850bd === 'function') {
    await nuxt_plugin_performance_1aa850bd(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_livechatevents_ea8c682a === 'function') {
    await nuxt_plugin_livechatevents_ea8c682a(app.context, inject)
  }

  if (typeof nuxt_plugin_checkout_520ca9a5 === 'function') {
    await nuxt_plugin_checkout_520ca9a5(app.context, inject)
  }

  if (typeof nuxt_plugin_customer_ea735fe6 === 'function') {
    await nuxt_plugin_customer_ea735fe6(app.context, inject)
  }

  if (typeof nuxt_plugin_shipping_35b2603d === 'function') {
    await nuxt_plugin_shipping_35b2603d(app.context, inject)
  }

  if (typeof nuxt_plugin_search_131c6c36 === 'function') {
    await nuxt_plugin_search_131c6c36(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
